'use client'

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { Pattern1 } from "@/(front-desk)/utils/patterns"
import { reportError } from "@/(front-desk)/utils/functions"
import Popup from "@/(front-desk)/components/Popup"
import classNames from "classnames"
import axios from "axios"
// import background from "@/(front-desk)/assets/images/background/default.png"

const Tag = (props) => {

    const { level, size } = props
    const levels = {
        S: '關鍵夥伴',
        A: '核心夥伴',
        B: '同行夥伴',
        C: '特別感謝'
    }

    return (
        <div className={classNames('font-semibold underline underline-offset-[0.75rem] whitespace-nowrap', {
            'text-main-200': level === 'S',
            'text-main-300': level === 'A',
            'text-main-400': level === 'B' || level === 'C',
            'p-[0.6rem] text-[1.5rem]': size !== 'sm',
            'py-1 px-2 text-[1.125rem]': size === 'sm'
        })}>{levels[level]}</div>
    )
}

export const Sponsors = () => {

    const dispatch = useDispatch()
    const sponsors = useSelector((state) => state.CMS).sponsors
    const [ active, setActive ] = useState(null)

    useEffect(() => {
        if (!sponsors) {
            axios.get(`/api/v1/cms/zh_hant/sponsors`)
            .then((res) => {
                // console.log(res.config?.url, res.data.body)
                dispatch(handleCMS.actions.setSponsors(res.data.body))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
    }, [])

    return (
        <>
        <div className="relative w-full flex-center flex-col py-[2.5rem] sm:py-[5rem] z-[1]">
            {/* <div className="absolute w-screen h-full pointer-events-none z-[-1]">
                <img className="w-full h-full object-cover opacity-[0.4]" src={background.src} />
            </div> */}
            <div className="sponsor-content w-full flex-center flex-col gap-6 md:gap-3">
                {['S', 'A', 'B', 'C'].filter(e => sponsors?.filter(s => s.tier === e).length > 0).map((level) => (
                    <div
                        key={`sponsor-category-${level}`}
                        className="w-full flex gap-[1.5rem] flex-col md:flex-row"
                    >
                        <div className="flex-center md:mt-[1.5rem] md:h-[6.3rem]">
                            <Tag level={level} />
                        </div>
                        <div className="flex flex-wrap justify-center md:justify-start gap-x-[1.5rem] gap-y-[3rem] w-full py-[1.5rem] px-[3rem] rounded-[1.25rem] bg-black">
                            { sponsors?.filter(sponsor => sponsor.tier === level).map((sponsor, index) => (
                                <button
                                    className="hover:scale-[1.05] transition"
                                    key={`sponsor-${index}`}
                                    onClick={() => {setActive(sponsor)}}
                                >
                                    <img
                                        className="w-[10.625rem] aspect-[10.625/6.25] object-contain"
                                        src={sponsor.logo}
                                        alt={`贊助商${sponsor.name}logo`}
                                    />
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>

        { active &&
            <Popup
                contentClassName="flex-center flex-col w-[40rem] !h-fit !bg-black-900 !rounded-[1.25rem]"
                onClose={() => {setActive(null)}}
            >
                <div className="absolute -bottom-1 w-[99.9%] h-1/2 bg-main rounded-[1.25rem] z-[-1]"></div>
                <img
                    className="w-full h-[20.5rem] object-contain mb-[1.5rem]"
                    src={active.logo}
                    alt={`贊助商${active.name}logo`}
                />
                <div className="w-full flex items-center gap-[1.12rem] mb-[1rem]">
                    <Tag level={active.tier} size="sm" />
                    <div className="text-[2.5rem] text-white font-semibold">
                        {active.name}
                    </div>
                </div>
                <div className="w-full text-white font-light mb-[2rem] whitespace-pre-wrap">
                    {active.description}
                </div>
                <div className="w-full flex flex-wrap justify-end gap-4">
                    { active.official_website &&
                        <a
                            href={active.official_website}
                            className="btn-main btn-round"
                            target="_blank"
                            title={`另開新視窗前往${active.name}官方網站`}
                        >前往官方網站</a>
                    }
                    {/* { active.job_link &&
                        <Link
                            href={active.job_link}
                            className="btn-main btn-round"
                        ></Link>
                    } */}
                </div>
            </Popup>
        }
        </>
    )
}

export default function sponsor() {
    return (
        <>
        <title>熱情贊助 - 放視大賞</title>
        <main className="sponsor">
            <div className="page-banner py-16">
                <div className="page-banner-content flex justify-between items-center">
                    <div>
                        <h1 className="title">Sponsor</h1>
                        <h2 className="sub-title">熱情贊助</h2>
                    </div>
                    <Pattern1 className="fill-main w-[4.5rem]" />
                </div>
            </div>
            <div id="main" className="content pb-10">
                <Sponsors />
            </div>
        </main>
        </>
    )
}